export default "__VITE_ASSET__DhRnXc8J__"